<template>
  <div class="flex items-center justify-end w-full gap-2 p-1 mb-2 border-t border-b">
    <slot></slot>
    <BaseTableControlsSearchBox
      v-model="searchQuery"
      @updateSearch="emit('updateSearch')"
      v-if="!isSearchHidden" />
    <template v-if="!onlySearch">
      <BaseControlsButtonIcon
        v-if="!isFilterButtonHidden"
        :tooltip-text="$t('common.tooltip.showFilter')"
        :active="isFiltersActive"
        @button-clicked="emit('filtersActive')">
        <template v-if="!isFiltersActive">
          <IconFilterList class="size-4" />
        </template>
        <template v-else>
          <IconFilterListOff class="size-4" />
        </template>
      </BaseControlsButtonIcon>

      <BaseControlsButtonIcon
        v-if="!isRefreshButtonHidden"
        :tooltip-text="$t('common.tooltip.refresh')"
        @click="onRefreshData">
        <IconRefresh class="size-4" />
      </BaseControlsButtonIcon>

      <BaseControlsButtonIcon
        v-if="!isSavingLayoutHidden"
        :active="isSavingLayout"
        @button-clicked="emit('saveLayout')"
        :tooltip-text="$t('common.tooltip.saveLayout')">
        <IconLayout class="size-4" />
      </BaseControlsButtonIcon>

      <BaseControlsButtonIcon
        v-if="!isDownloadButtonHidden"
        :tooltip-text="$t('common.tooltip.download')"
        @click="emit('exportToExcel')">
        <IconDownload class="size-4" />
      </BaseControlsButtonIcon>

      <button
        v-if="!isAddNewHidden"
        type="button"
        @click="emit('addNew')"
        class="px-2 py-1 font-normal border border-gray-300 rounded-md">
        <span class="flex items-center justify-center gap-2 text-sm capitalize text-theme-500">
          <IconAddSmall />
          <p v-if="addButtonText">{{ addButtonText }}</p>
          <p v-else>{{ $t('common.actions.addNew') }}</p>
        </span>
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
import BaseTableControlsSearchBox from './BaseTableControlsSearchBox.vue';
import BaseControlsButtonIcon from './BaseControlsButtonIcon.vue';
import IconLayout from '@/assets/icons/IconLayout.vue';
import IconFilterList from '@/assets/icons/IconFilterList.vue';
import IconFilterListOff from '@/assets/icons/IconFilterListOff.vue';
import IconRefresh from '@/assets/icons/IconRefresh.vue';
import IconDownload from '@/assets/icons/IconDownload.vue';
import IconAddSmall from '@/assets/icons/IconAddSmall.vue';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n({ useScope: 'global' });

defineProps<{
  isSavingLayout?: boolean;
  isSavingLayoutHidden?: boolean;
  isFiltersActive?: boolean;
  isFilterButtonHidden?: boolean;
  isSearchHidden?: boolean;
  onlySearch?: boolean;
  isAddNewHidden?: boolean;
  isDownloadButtonHidden?: boolean;
  isRefreshButtonHidden?: boolean;
  addButtonText?: string;
}>();

const emit = defineEmits([
  'saveLayout',
  'filtersActive',
  'exportToExcel',
  'refreshData',
  'updateSearch',
  'addNew',
  'addAll',
]);

const searchQuery = defineModel<string>();
function onRefreshData() {
  emit('refreshData');
  searchQuery.value = '';
}
</script>
